import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { fetchQuizAnalytics } from "../../../services/automapBuyerAnalyticsApi";
import {
  AdminAnalyticsNav,
  AnalyticsBreakdownTable,
  AnalyticsRangeSelect,
  AnalyticsSummaryGrid,
} from "./AdminAnalyticsShared";

export default function AdminQuizAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchQuizAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar quiz."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Analytics"
        title="Analytics del quiz"
        description="Inicio, completación, presupuestos y conversión a leads."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="quiz" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error && totals ? (
          <>
            <AnalyticsSummaryGrid
              items={[
                { label: "Inicios", value: totals.starts },
                { label: "Completados", value: totals.completions },
                {
                  label: "Tasa completación",
                  value: totals.completionRate != null ? `${totals.completionRate}%` : "—",
                },
                { label: "Vistas resultados", value: totals.resultsViews },
                { label: "Clics recomendación", value: totals.recommendationClicks },
                { label: "Leads", value: totals.leads },
                {
                  label: "Quiz → lead",
                  value: totals.leadRate != null ? `${totals.leadRate}%` : "—",
                },
              ]}
            />
            <div className="admin-analytics-grid">
              <AnalyticsBreakdownTable title="Abandono por paso" rows={payload.dropOffByStep} keyLabel="Paso" />
              <AnalyticsBreakdownTable title="Presupuestos populares" rows={payload.popularBudgets} keyLabel="Presupuesto" />
              <AnalyticsBreakdownTable title="Ciudades populares" rows={payload.popularCities} />
            </div>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
